module.exports = __webpack_public_path__ + "static/media/21ECLAC19.a3196902.jpg";